import type { Logger } from '../core/types';

export class ConsoleLogger implements Logger {
  public info(message: string, details?: Readonly<Record<string, unknown>>): void {
    if (details === undefined) console.info(`[Selfie Sprint] ${message}`);
    else console.info(`[Selfie Sprint] ${message}`, details);
  }

  public error(message: string, error?: unknown): void {
    console.error(`[Selfie Sprint] ${message}`, error);
  }
}
